var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCopy16X16 = function SvgCopy16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.678 3.01H5.87a1.64 1.64 0 00-1.634 1.635v11.441H5.87V4.645h9.808V3.01zm2.451 3.27H9.14a1.64 1.64 0 00-1.634 1.634v11.441A1.64 1.64 0 009.14 20.99h8.99a1.64 1.64 0 001.634-1.634V7.913a1.64 1.64 0 00-1.634-1.635zm0 13.075H9.14V7.914h8.99v11.441z",
    fill: "#9CA6AD"
  })));
};

export default SvgCopy16X16;